import React, { useState } from 'react'
import graphql from 'babel-plugin-relay/macro'
import { fetchQuery } from 'config/amber-relay'
import Select from 'components/v2/Select'

export default function ExpenseTypeSelect(props) {
  const { onChangeWithData, excludeVehicleExpenses = false, onlyVehicleExpenses = false, ...restProps } = props;
  const [options, setOptions] = useState([]);

  const getBaseFilter = () => {
    if (excludeVehicleExpenses) return { forVehicles: { eq: "false" } };
    if (onlyVehicleExpenses) return { forVehicles: { eq: "true" } };
    return null;
  };

  const fetch = async (additionalWhere = {}) => {
    const baseFilter = getBaseFilter();

    const filters = [];
    if (baseFilter) filters.push(baseFilter);
    if (Object.keys(additionalWhere).length > 0) filters.push(additionalWhere);

    const completeWhere = filters.length > 1
      ? { and: filters }
      : filters.length === 1
        ? filters[0]
        : {};

    try {
      const result = await fetchQuery(
        graphql`
          query ExpenseTypeSelectQuery($where: ExpenseTypeWhere) {
            expenseTypes(where: $where, orderBy: [code], order: ASC) {
              edges {
                node {
                  id
                  name
                  forVehicles
                }
              }
            }
          }
        `,
        { where: completeWhere }
      );

      const newOptions = result.expenseTypes.edges.map(({ node }) => ({
        key: node.id,
        value: node.id,
        text: node.name,
        data: {
          id: node.id,
          forVehicles: node.forVehicles
        }
      }));

      setOptions(prevOptions => {
        const mergedOptions = [...prevOptions];
        newOptions.forEach(newOption => {
          if (!mergedOptions.find(opt => opt.value === newOption.value)) {
            mergedOptions.push(newOption);
          }
        });
        return mergedOptions;
      });

      return newOptions;
    } catch (error) {
      console.error("Error en la consulta:", error);
      throw error;
    }
  };

  const handleChange = (value) => {
    if (onChangeWithData) {
      const selectedOption = options.find(option => option.value === value);
      if (selectedOption) {
        onChangeWithData(selectedOption.data);
      }
    }

    if (restProps.onChange) {
      restProps.onChange(value);
    }
  };

  return (
    <Select
      {...restProps}
      getByValue={value => fetch({ id: { eq: value } })}
      loadOptions={searchQuery => {
        if (searchQuery && searchQuery.trim() !== "") {
          return fetch({ name: { iLike: `${searchQuery}%` } });
        } else {
          return fetch({});
        }
      }}
      onChange={handleChange}
    />
  );
}

ExpenseTypeSelect.defaultProps = {
  label: 'Tipo de Gasto',
  placeholder: 'Tipo de Gasto',
  loadOnMount: true,
}